import { createPageApp } from '@/lib/createPageApp'
import ArticlePage from './ArticlePage.vue'

createPageApp(ArticlePage).mount()
